import { render, staticRenderFns } from "./newMenuItem.vue?vue&type=template&id=ffdc598e"
import script from "./newMenuItem.vue?vue&type=script&lang=js"
export * from "./newMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffdc598e')) {
      api.createRecord('ffdc598e', component.options)
    } else {
      api.reload('ffdc598e', component.options)
    }
    module.hot.accept("./newMenuItem.vue?vue&type=template&id=ffdc598e", function () {
      api.rerender('ffdc598e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/newMenuItem.vue"
export default component.exports